import * as moment from 'moment'
import 'moment-timezone'

/**
 * Check whether the current date falls between
 * two other dates
 *
 * @param {String} timezone
 * The timezone the promotion is running in
 *
 * @param {Object} promotionDates
 * The promotion dates
 */
const isInside = (timezone: string, { startDateTime, endDateTime, daysFromPurchase, daysAfterPurchase, claimFormOpens }: any) => {
  const nowRaw = moment()
  const startDateRaw = moment.tz(startDateTime, timezone)
  const endDateRaw = moment.tz(endDateTime, timezone)
  const daysBeforeClaim = daysFromPurchase ?? 0
  const daysToClaim = daysAfterPurchase ?? 0
  const claimFormOpensDate = claimFormOpens ? moment.tz(claimFormOpens, timezone) : startDateRaw.add(daysBeforeClaim, 'days')
  const claimFormClosesDate = endDateRaw.add(daysBeforeClaim + daysToClaim, 'days')

  return claimFormOpensDate.isBefore(nowRaw) && claimFormClosesDate.isAfter(nowRaw)
}

/**
 * Check whether the current date & time falls between two other
 * dates and times
 *
 * @param {Object} dates
 * The start and end dates
 *
 * @param {Date} now
 * The current local time NOT converted to UTC
 */
const isInsideToday = (timezone: string, dates: any, now: string) => {
  const nowRaw = moment.tz(now, timezone)
  const nowDay = nowRaw.format('YYYY-MM-DD')
  const openTime = `${nowDay}T${dates.openTime || '00:00:00'}`
  const closeTime = `${nowDay}T${dates.closeTime || '23:59:59'}`
  const openRaw = moment.tz(openTime, timezone)
  const closeRaw = moment.tz(closeTime, timezone)

  return isInside(timezone, dates) && openRaw.isBefore(now) && closeRaw.isAfter(now)
}

export { isInside, isInsideToday }
